module.exports = __webpack_public_path__ + "img/tut_no.7c28c300.png";